import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Card, Input, Select, Tabs } from "antd";
import { AxiosGetSecretApi } from "../../../../utils/fetchApi";

class SearchQHPK extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listPhanKhu: [],

      listPhanKhuConst: [],

      SoQD: undefined,
      NamQH: undefined,
      selectedPhanKhu: undefined,
    };
  }


  componentDidMount() {
    this.getDataDuAn();
  }

  async getDataDuAn() {
    let res = await AxiosGetSecretApi("/api/qh-phan-khu/cbTenDuAn");
    if (res && Array.isArray(res)) {
      this.setState({ listPhanKhu: res, listPhanKhuConst: res });
      this.listPhanKhu = res;
    }
  }

  onResetButton() {
    this.setState({
      listPhanKhu: this.state.listPhanKhuConst,
      SoQD: undefined,
      NamQH: undefined,
      selectedPhanKhu: undefined,
    });
  }

  onSearch() {
    let data = {
      selectedPhanKhu: this.state.selectedPhanKhu,
    };
    
    this.props.onSearchQHPK(data);
  }

  render() {
    return (
      <div className="popup-search" style={{zIndex: 14}}>
        <div className="title font-size-16">
          Tìm kiếm thông tin
          <i
            className="fas fa-times icon-close"
            onClick={() => {
              this.props.close();
            }}
          ></i>
        </div>

        <Card title="Quy hoạch phân khu 1/5000" size="small" >
          <div className="body">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <div>
                  <div className="group">
                    <div className="gr-title">
                      
                      <div className="text">Số quyết định</div>
                    </div>

                    <div className="gr-body">
                      <Input
                        className="input"
                        value={this.state.SoQD}
                        onChange={(e) => {
                          const value = e.target.value;
                          this.setState({ SoQD: value });
                          const listPhanKhu = this.state.listPhanKhuConst.filter(e => e.QuyetDinhPhapLy === value)
                          this.setState({listPhanKhu})
                        }}
                      ></Input>
                    </div>
                  </div>

                  <div className="group">
                    <div className="gr-title">
                      <div className="text">Năm quy hoạch</div>
                    </div>

                    <div className="gr-body">
                      <Input
                        className="input"
                        value={this.state.NamQH}
                        onChange={(e) => {
                          const value = e.target.value;
                          this.setState({ NamQH: value });
                          const listPhanKhu = this.state.listPhanKhuConst.filter(e => e.NamQH === value)
                          this.setState({listPhanKhu})
                        }}
                      ></Input>
                    </div>
                  </div>

                  <div className="group">
                    <div className="gr-title">
                      <div className="required">*</div>
                      <div className="text">Tên phân khu</div>
                    </div>

                    <div className="gr-body">
                      <Select
                        className="select"
                        showSearch
                        value={this.state.selectedPhanKhu}
                        onChange={(value, option) =>
                          this.setState({selectedPhanKhu: value})
                        }
                      >
                        {this.state.listPhanKhu.map((e, i) => (
                          <Select.Option
                            value={e.TenPhanKhu}
                            key={i}
                            id={e.OBJECTID}
                          >
                            {e.TenPhanKhu}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    type="primary"
                    className="button"
                    onClick={() => {
                      this.onResetButton();
                    }}
                  >
                    Tìm mới
                  </Button>
                  <Button
                    type="primary"
                    className="button"
                    onClick={() => {
                      this.onSearch();
                    }}
                    disabled={
                      this.state.selectedPhanKhu
                        ? false
                        : true
                    }
                  >
                    Tìm kiếm
                  </Button>
                </div>
              </div>
            </div>

            <div className="footer" style={{position: "unset"}}>
              <div style={{ display: "flex"}}>
                <div className="required">*</div>
                <div className="text">Thông tin bắt buộc</div>
              </div>
            </div>
          </Card>

        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // listQuan: state.search.listQuan,
    // listPhuong: state.search.listPhuong,
    // listDuong: state.search.listDuong,
    // listDuAn: state.search.listDuAn,
  };
};

const mapDispatchToProps = {
  // getDataQuan: getDataQuan,
  // getDataPhuong: getDataPhuong,
  // getDataDuong: getDataDuong,
  // getDataDuAn: getDataDuAn,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchQHPK);
